import { Component, ContentChild } from '@angular/core';
import { RecordCardGenericLeftDirective } from 'src/app/directives/record-card-generic-left.directive';
import { RecordCardGenericRightDirective } from 'src/app/directives/record-card-generic-right.directive';

@Component({
  selector: 'app-record-card-generic',
  templateUrl: './record-card-generic.component.html',
  styleUrls: ['./record-card-generic.component.scss'],
})
export class RecordCardGenericComponent {
  @ContentChild(RecordCardGenericLeftDirective) left!: RecordCardGenericLeftDirective;

  @ContentChild(RecordCardGenericRightDirective) right!: RecordCardGenericRightDirective;
}
